import { Directive, ElementRef, TemplateRef, ViewContainerRef, ViewChildren, QueryList, Input, AfterViewInit, Injector } from "@angular/core";
import { LocalizePipe } from "../../pipes/Localize.pipe";
import { DiagnosedItem } from "../../dataModels/diagnosed-item";

@Directive({
    selector: '[localize]'
})
export class LocalizeDirective extends DiagnosedItem implements AfterViewInit {
    @ViewChildren(TemplateRef) templates: QueryList<TemplateRef<any>>;

    constructor(private localize: LocalizePipe, protected inj: Injector,
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef
    ) {
        super(inj);
        this.viewContainer.createEmbeddedView(this.templateRef);
    }

    ngAfterViewInit() {

        setTimeout(() => {
            console.log(this.templateRef.elementRef);
            console.log(this.templates);
        }, 1000);
        // let native = this.templateRef.elementRef.nativeElement

        // let txt = native.innerHTML;
        // let otherText = '';
        // let n = txt.length, i = 0;

        // for (; i < n - 1; i++) {
        //     if (txt[i] == '@' && txt[i + 1] == '@') {
        //         let g = '';
        //         i += 2;
        //         while (i < n && txt[i] != ' ') {
        //             g += txt[i];
        //             i++;
        //         }

        //         otherText += this.localize.transform(g, 'operations');
        //     } else {
        //         otherText += txt[i];
        //     }
        // }

        // if (i == n - 1) otherText += txt[i];

        // native.innerHTML = otherText;
        // console.log(otherText);

        // this.viewContainer.createEmbeddedView(this.templateRef);
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/localize/localize.directive.ts